import { TableColumnAlignment } from '@triumph/design-system';
import { useMemo } from 'react';
import {
    StyledParagraphCell,
    StyledTableCell,
    TableCellProps,
} from '../StyledComponents/TableCellStyledComponents';

const TableCell: React.FC<TableCellProps> = ({
    value,
    row,
    column,
    textWrapMode,
}) => {
    const valueDisplay = useMemo(() => {
        if (!column) return value;

        if (column.columnFormatter) {
            return column.columnFormatter(value, row);
        } else if (column.dynamicColumnFormatter) {
            return column.dynamicColumnFormatter(value, row);
        }

        return <StyledParagraphCell>{value}</StyledParagraphCell>;
    }, [value, column]);

    const alignment = useMemo(() => {
        switch (column?.columnAlignment) {
            case TableColumnAlignment.Right:
                return 'right';
            case TableColumnAlignment.Left:
            default:
                return 'left';
        }
    }, [column]);

    return (
        <StyledTableCell
            columnAlignment={column?.columnAlignment}
            textWrapMode={textWrapMode}
            textAlign={alignment}
            value={value}
            colSpan={column?.colSpan}
        >
            {valueDisplay}
        </StyledTableCell>
    );
};
export default TableCell;
